import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { BaseEntity } from '../base/BaseEntity';
import { MatSelectChange } from '@angular/material/select';
import { DocumentTypeService } from '../services/document-type.service';
import { EnviromentService } from '../services/enviroment.service';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'document-type-combo',
  templateUrl: './document-type-combo.component.html',
  styleUrls: ['./document-type-combo.component.css']
})
export class DocumentTypeComboComponent implements OnInit, OnChanges {

  @Input() value: any;
  @Input() disabled: boolean;
  @Input() selectFirst: boolean;

  @Output() selectedChange = new EventEmitter<BaseEntity>();
  private lastDocumentTypeKey = 'LASTDOCUMENTTYPE';
  current: BaseEntity ;
  currentId: string = null;
  data: BaseEntity[];
  selected: any;
  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    const value = changes['value'];
    if (value) {
      if ( value.currentValue !== value.previousValue) {
        this.currentId = value.currentValue;
        this.selectCurrent();
      }
    }
  }
  select(type) {
    this.current = type;
    if (this.current) {
      this.currentId = this.current.id;
      this.selectedChange.emit(type);
    }
  }
  selectCurrent() {
    if (this.data && this.currentId) {
      const ret = this.data.find(elem => elem.id === this.currentId);
      this.current = ret;
      this.selectedChange.emit(ret);
    }
  }
  constructor(
    public documentTypes: DocumentTypeService,
    private enviromentService: EnviromentService
  ) {

  }

  ngOnInit() {
    this.documentTypes.GetCached().subscribe((result: any) => {
      this.data = result;
      if (this.selectFirst && this.data && this.data.length > 0) {
        const lastTypeId = this.enviromentService.getLocal(this.lastDocumentTypeKey);
        if(lastTypeId) {
          const lastType = this.data.filter(f => f.id === lastTypeId);
          if(lastType) {
            this.select(lastType[0]);
          }
          else {
            this.select(this.data[0]);
          }
        }
        else {
          this.select(this.data[0]);
        }
      }
      this.selectCurrent();
    });
  }
  OnSelected(e: MatSelectChange) {
    if (this.data && e.value && e.value) {
      this.current = this.data.find(elem => elem.id === e.value.id);
      this.enviromentService.storeLocal(this.lastDocumentTypeKey, this.current.id);
      this.selectedChange.emit(this.current);
    }
  }
}
